module.exports = __webpack_public_path__ + "static/media/img-mobile-recommendation.5ae9120d.png";